import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { isEqual, head, get } from 'lodash';
import createStore from '../../store';
import sessionPropTypes from '../../states/session/propTypes';
import LayoutContainer from '../LayoutContainer/LayoutContainer';
import accountPropTypes from '../../states/accounts/propTypes';
import { setAccounts } from '../../states/accounts/actions';
import { setUser } from '../../states/user/actions';
import { getAllBeneficiaries } from '../../states/payees/actions';
import { getCustomerCapabilities } from '../../states/capabilities/actions';

class PaymentAuthApp extends Component {
	constructor(props) {
		super(props);

		const { session, envConfig, accounts, user, isLCV, isSme, hasGroupApprovalsEnabled = false } = this.props;
		this.store = createStore({
			session: { ...session, isLCV, isSme, hasGroupApprovalsEnabled },
			envConfig,
			accounts,
			user,
		});
		this.store.dispatch(getAllBeneficiaries());
	}

	componentDidMount() {
		const {
			session: { bankId },
			user: { customers = [] },
		} = this.props;
		const customerId = get(head(customers), 'customer_id');
		this.store.dispatch(getCustomerCapabilities(bankId, customerId));
	}

	componentDidUpdate(prevProps) {
		const { user, accounts } = this.props;

		if (!isEqual(user, prevProps.user)) {
			this.store.dispatch(setUser(user));
		}

		if (!isEqual(accounts, prevProps.accounts)) {
			this.store.dispatch(setAccounts(accounts));
		}
	}

	render() {
		const { handleRoute, handleRefresh, handleEdit, handleIsListing, handleEditById } = this.props;

		return (
			<Provider store={this.store}>
				<div className="web-ui-components">
					<LayoutContainer
						handleRoute={handleRoute}
						handleRefresh={handleRefresh}
						handleEdit={handleEdit}
						handleIsListing={handleIsListing}
						handleEditById={handleEditById}
					/>
				</div>
			</Provider>
		);
	}
}

PaymentAuthApp.propTypes = {
	session: PropTypes.shape(sessionPropTypes).isRequired,
	envConfig: PropTypes.shape({
		apiBaseUrl: PropTypes.string,
		apiBankId: PropTypes.string,
		brandId: PropTypes.string,
		isSavingsPotsEnabled: PropTypes.bool,
		isSpendingsEnabled: PropTypes.bool,
		isTaggingEnabled: PropTypes.bool,
		isFinancialStoryEnabled: PropTypes.bool,
		isContactDetailsEnabled: PropTypes.bool,
		isHelpDemoEnabled: PropTypes.bool,
		isSweepsEnabled: PropTypes.bool,
		isNBAEnabled: PropTypes.bool,
		isNicknameAmendEnabled: PropTypes.bool,
		callValidate3DTimelimit: PropTypes.number,
		disableAnalytics: PropTypes.bool,
		trackingId: PropTypes.string,
		disableNavigationWarning: PropTypes.bool,
		enableWindowStubs: PropTypes.bool,
		stubApiData: PropTypes.bool,
		isSecureMessageEnabled: PropTypes.bool,
		targetScope: PropTypes.shape({
			unknown: PropTypes.number,
			notAuthed: PropTypes.number,
			authentication: PropTypes.number,
			login: PropTypes.number,
		}),
		websiteBaseDirectory: PropTypes.string,
		autoLoginTimeout: PropTypes.number,
		nextTaskCheckInterval: PropTypes.number,
		defaultAutoSaveInterval: PropTypes.number,
		shortAutoSaveInterval: PropTypes.number,
		publicKeyExpiry: PropTypes.number,
		tokenInactivityTimeout: PropTypes.number,
		statementsURl: PropTypes.string,
		idvRedirectURL: PropTypes.string,
		redirectToBOW: PropTypes.string,
		manageContactDetailsLink: PropTypes.string,
		marketingPreferenceLink: PropTypes.string,
		manageCredentialLink: PropTypes.string,
		malwareurl: PropTypes.string,
		eGainLiveServerURL: PropTypes.string,
		coBrowseScriptID: PropTypes.string,
		domainName: PropTypes.string,
		secureMessageURL: PropTypes.string,
	}).isRequired,
	handleRoute: PropTypes.func.isRequired,
	handleRefresh: PropTypes.func,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	user: PropTypes.shape({
		sub_segment: PropTypes.string,
		customers: PropTypes.array,
	}),
	handleEdit: PropTypes.func,
	handleIsListing: PropTypes.func,
	handleEditById: PropTypes.func,
	isLCV: PropTypes.bool.isRequired,
	isSme: PropTypes.bool.isRequired,
	hasGroupApprovalsEnabled: PropTypes.bool,
};

export { PaymentAuthApp };
